export class CopyTransactionFunctionalAnalysisErrorResponse {
  sourceId: any;
  uncontrolled: any;
}
